// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"2f89d587042d3df5","6831":"1b6930114f73fa23","8503":"11dedc5d5a64a156","9683":"c3cc771d0f1970c2"}[chunkId] + ".js";
};